/* @flow */

import { connect } from 'react-redux';
import { get } from 'lodash/fp';
import styled from '@emotion/styled';

const Cell = styled.div(({ important, highlight, separate, theme }) => ({
  alignItems: 'center',
  borderRight: separate ? '1px solid #ececec' : 0,
  borderBottom: '1px solid #ececec',
  display: 'flex',
  fontWeight: highlight && theme.fontWeight.bold,
  color: highlight && theme.color.widgetPrimary,
  justifyContent: 'center',
  padding: '0 0.5em',
  textTransform: important ? 'uppercase' : 'initial',
  whiteSpace: 'nowrap'
}));

const connector = connect(
  (state, ownProps) => {
    const { columnIndex, style, data, categories } = ownProps;

    if (columnIndex === 0) {
      return {
        children: data.label,
        style
      };
    }

    const index = columnIndex - 1;
    const statKey = get(`[${index}].id`)(categories);

    return {
      children: get(statKey)(data.stats) || '–',
      style
    };
  },
  {}
);

export default connector(Cell);
